<div class="card">
  <div class="card-header">
    <h2 class="card-title">Gerenciamento de Planos de Acesso</h2>
    <button mat-fab extended color="primary" (click)="openPlanDialog()">
      <mat-icon>add</mat-icon>
      Novo Plano
    </button>
  </div>

  <div class="card-body">
    <!-- SEÇÃO DE FILTROS -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>filter_list</mat-icon>
          Filtros de Busca
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="filters-content">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>CPF/CNPJ</mat-label>
          <input matInput [(ngModel)]="filterCpfCnpj" placeholder="Digite apenas números">
          <mat-icon matSuffix>search</mat-icon>
          <mat-hint>CPF: 11 dígitos ou CNPJ: 14 dígitos</mat-hint>
        </mat-form-field>

        <mat-checkbox [(ngModel)]="showOnlyActive">
          Mostrar apenas ativos
        </mat-checkbox>

        <div class="filter-actions">
          <button mat-raised-button color="primary" (click)="applyFilters()" class="btn btn-primary">
            <mat-icon>search</mat-icon>
            Aplicar Filtros
          </button>
          <button mat-stroked-button (click)="clearFilters()" class="btn btn-ghost">
            <mat-icon>clear</mat-icon>
            Limpar
          </button>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- TABELA DE PLANOS -->
    <div class="table-container">
      <h3 class="title-section">Lista de Planos</h3>
      <table mat-table [dataSource]="accessPlans" class="plans-table">
        <!-- Coluna ID -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let plan">{{ plan.id }}</td>
        </ng-container>

        <!-- Coluna Nome -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nome</th>
          <td mat-cell *matCellDef="let plan">{{ plan.name }}</td>
        </ng-container>

        <!-- Coluna CPF/CNPJ -->
        <ng-container matColumnDef="cpfcnpj">
          <th mat-header-cell *matHeaderCellDef>CPF/CNPJ</th>
          <td mat-cell *matCellDef="let plan">{{ formatCpfCnpj(plan.cpfcnpj) }}</td>
        </ng-container>

        <!-- Coluna Status -->
        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let plan">
            <span class="badge" [ngClass]="plan.active ? 'badge-success' : 'badge-error'">
              {{ plan.active ? 'Ativo' : 'Inativo' }}
            </span>
          </td>
        </ng-container>

        <!-- Coluna Itens -->
        <ng-container matColumnDef="items">
          <th mat-header-cell *matHeaderCellDef>Itens</th>
          <td mat-cell *matCellDef="let plan">{{ getItemsCount(plan) }}</td>
        </ng-container>

        <!-- Coluna Descontos -->
        <ng-container matColumnDef="discounts">
          <th mat-header-cell *matHeaderCellDef>Descontos</th>
          <td mat-cell *matCellDef="let plan">{{ getDiscountsCount(plan) }}</td>
        </ng-container>

        <!-- Coluna Data de Criação -->
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>Criado em</th>
          <td mat-cell *matCellDef="let plan">{{ formatDate(plan.createdAt) }}</td>
        </ng-container>

        <!-- Coluna Ações -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Ações</th>
          <td mat-cell *matCellDef="let plan">
            <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openPlanDetailsDialog(plan)">
                <mat-icon>info</mat-icon>
                <span>Detalhes</span>
              </button>
              <button mat-menu-item (click)="openPlanFullDetailsDialog(plan.id!)">
                <mat-icon>visibility</mat-icon>
                <span>Ver Detalhes Completos</span>
              </button>
              <button mat-menu-item (click)="editPlan(plan)">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="togglePlanStatus(plan)">
                <mat-icon>{{ plan.active ? 'block' : 'check_circle' }}</mat-icon>
                <span>{{ plan.active ? 'Desativar' : 'Ativar' }}</span>
              </button>
              <button mat-menu-item (click)="deletePlan(plan.id!)" class="delete-action">
                <mat-icon>delete</mat-icon>
                <span>Excluir</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            Nenhum plano encontrado
          </td>
        </tr>
      </table>

      <div class="table-footer">
        <small>Total de planos: {{ accessPlans.length }}</small>
      </div>
    </div>
  </div>
</div>